import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import RegisteredSite from "api/types/models/registered_site";
import User from "api/types/models/user";

export interface AuthState {
  authenticated: boolean;
  user: User | null;
  registered_site: RegisteredSite | null;
  change_password_step: number;
  comms_auth_token: string | null;
}

const initialState: AuthState = {
  authenticated: false,
  user: null,
  registered_site: null,
  change_password_step: 1,
  comms_auth_token: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{ user: User; registered_site?: RegisteredSite }>,
    ) => {
      state.authenticated = true;
      state.user = action.payload.user;

      if (action.payload?.registered_site) {
        state.registered_site = action.payload.registered_site;
      }
    },
    logout: (state) => {
      if (state.authenticated) {
        window.location.reload();
      }
    },
    clearAuth: (state) => {
      state.authenticated = false;
      state.user = null;
      state.change_password_step = 1;
      state.comms_auth_token = null;
    },
    nextChangePasswordStep: (state) => {
      state.change_password_step++;
    },
    previousChangePasswordStep: (state) => {
      state.change_password_step--;
    },
    clearChangePasswordStep: (state) => {
      state.change_password_step = initialState.change_password_step;
    },
    setCommsToken: (state, action) => {
      state.comms_auth_token = state.comms_auth_token = action.payload.token;
    },
  },
});

export const {
  login,
  logout,
  clearAuth,
  nextChangePasswordStep,
  clearChangePasswordStep,
  previousChangePasswordStep,
  setCommsToken,
} = authSlice.actions;

export default authSlice.reducer;
